import * as React from 'react';

import { Pill } from '@components/common';
import { ViewSVG } from '@components/svgs';

import { SKIP_LOGIC_OP } from '../../constants';
import { answerValueIsArray, RuleLogic } from '../utils';

const UNTITLED_QUESTION = '(Untitled question)';

interface QuestionPillProps {
  question: ScreenerField;
}

const QuestionPill: React.FC<QuestionPillProps> = ({ question }) => (
  <Pill className='normal-case' color='white'>
    <div className='flex items-center space-x-1'>
      <ViewSVG />
      <span>{`Q${question.position}: ${question.label || UNTITLED_QUESTION}`}</span>
    </div>
  </Pill>
);

interface OperatorPillProps {
  operator: string;
}

const OperatorPill: React.FC<OperatorPillProps> = ({ operator }) => (
  <Pill className='capitalize' color='white'>
    {SKIP_LOGIC_OP[operator]}
  </Pill>
);

interface AnswerValuePillsProps {
  answerValue: RuleLogic['answer_value'];
  fieldType: ScreenerField['field_type'];
  operator: RuleLogic['operator'];
}

const AnswerValuePills: React.FC<AnswerValuePillsProps> = ({ answerValue, fieldType, operator }) => {
  if (answerValueIsArray(fieldType, operator)) {
    const values = Array.isArray(answerValue) ? answerValue : [answerValue];
    return (
      <>
        {values.map((value, index) => (
          <Pill key={index} className='normal-case' color='white'>
            {value}
          </Pill>
        ))}
      </>
    );
  }

  return (
    <Pill className='normal-case' color='white'>
      {answerValue}
    </Pill>
  );
};

interface RuleLogicProps {
  logic: RuleLogic;
  question: ScreenerField;
}

export const RuleLogicSummary: React.FC<RuleLogicProps> = ({ question, logic }) => {
  return (
    <div className='flex items-center space-x-2'>
      <strong>If</strong>
      <QuestionPill question={question} />
      <OperatorPill operator={logic.operator} />
      <AnswerValuePills answerValue={logic.answer_value} fieldType={question.field_type} operator={logic.operator} />
    </div>
  );
};
